export const messagesWithToolCalls = [
  {
    type: "human",
    content: "hi",
  },
  {
    content: "Hello! How can I assist you today?",
    additional_kwargs: {},
    response_metadata: {
      usage: {
        prompt_tokens: 6818,
        completion_tokens: 11,
        total_tokens: 6829,
        prompt_tokens_details: {
          cached_tokens: 0,
          audio_tokens: 0,
        },
        completion_tokens_details: {
          reasoning_tokens: 0,
          audio_tokens: 0,
          accepted_prediction_tokens: 0,
          rejected_prediction_tokens: 0,
        },
      },
    },
    tool_call_chunks: [],
    id: "chatcmpl-BUfPGsrmZ5ZufWkDhOxcWbxis3kEp",
    tool_calls: [],
    invalid_tool_calls: [],
    type: "ai",
  },
  {
    type: "human",
    content: 'Please create a purple button that says "Learn More Now"',
  },
  {
    content: "",
    additional_kwargs: {
      tool_calls: [
        {
          index: 0,
          id: "call_lOeaSFXOwgScogU9qzL9RBdH",
          type: "function",
          function: {
            name: "add_component",
            arguments:
              '{"id":null,"component":{"type":"AdvancedButton","caption1":"Learn More Now","caption1style":{"color":"#ffffff","display":"inline-block","fontFamily":"Arial","fontSize":"1rem","fontWeight":"bold"},"properties":{"display":"inline-block","textAlign":"center","padding":"10px 20px","backgroundColor":"#800080","border":"none","borderRadius":5},"actions":[{"type":"GO_TO_URL","name":"Learn More","payload":{"url":"#"},"behavior":"click"}],"parent":"root","id":"learnMoreButton"}}',
          },
        },
      ],
    },
    response_metadata: {
      usage: {
        prompt_tokens: 6847,
        completion_tokens: 132,
        total_tokens: 6979,
        prompt_tokens_details: {
          cached_tokens: 6784,
          audio_tokens: 0,
        },
        completion_tokens_details: {
          reasoning_tokens: 0,
          audio_tokens: 0,
          accepted_prediction_tokens: 0,
          rejected_prediction_tokens: 0,
        },
      },
    },
    tool_call_chunks: [
      {
        name: "add_component",
        args: '{"id":null,"component":{"type":"AdvancedButton","caption1":"Learn More Now","caption1style":{"color":"#ffffff","display":"inline-block","fontFamily":"Arial","fontSize":"1rem","fontWeight":"bold"},"properties":{"display":"inline-block","textAlign":"center","padding":"10px 20px","backgroundColor":"#800080","border":"none","borderRadius":5},"actions":[{"type":"GO_TO_URL","name":"Learn More","payload":{"url":"#"},"behavior":"click"}],"parent":"root","id":"learnMoreButton"}}',
        id: "call_lOeaSFXOwgScogU9qzL9RBdH",
        index: 0,
        type: "tool_call_chunk",
      },
    ],
    id: "chatcmpl-BUfPbLrBmaymez2d4xHV3hV9UBvHG",
    tool_calls: [
      {
        name: "add_component",
        args: {
          id: null,
          component: {
            type: "AdvancedButton",
            caption1: "Learn More Now",
            caption1style: {
              color: "#ffffff",
              display: "inline-block",
              fontFamily: "Arial",
              fontSize: "1rem",
              fontWeight: "bold",
            },
            properties: {
              display: "inline-block",
              textAlign: "center",
              padding: "10px 20px",
              backgroundColor: "#800080",
              border: "none",
              borderRadius: 5,
            },
            actions: [
              {
                type: "GO_TO_URL",
                name: "Learn More",
                payload: {
                  url: "#",
                },
                behavior: "click",
              },
            ],
            parent: "root",
            id: "learnMoreButton",
          },
        },
        id: "call_lOeaSFXOwgScogU9qzL9RBdH",
        type: "tool_call",
      },
    ],
    invalid_tool_calls: [],
    type: "ai",
  },
  {
    content:
      '{\n  "content": "A AdvancedButton element was added to the page.",\n  "intention": "ADD_COMPONENT",\n  "diff": [\n    {\n      "type": "ADD",\n      "id": null,\n      "value": {\n        "type": "AdvancedButton",\n        "properties": {\n          "display": "inline-block",\n          "textAlign": "center",\n          "padding": "10px 20px",\n          "border": "none",\n          "borderRadius": 5,\n          "backgroundColor": "#800080"\n        },\n        "caption1": "Learn More Now",\n        "caption1style": {\n          "color": "#ffffff",\n          "display": "inline-block",\n          "fontFamily": "Arial",\n          "fontSize": "1rem",\n          "fontWeight": "bold"\n        },\n        "actions": [\n          {\n            "type": "GO_TO_URL",\n            "name": "Learn More",\n            "payload": {\n              "url": "#"\n            },\n            "behavior": "click"\n          }\n        ],\n        "parent": "root",\n        "id": "learnMoreButton"\n      }\n    }\n  ]\n}',
    tool_call_id: "call_lOeaSFXOwgScogU9qzL9RBdH",
    name: "add_component",
    additional_kwargs: {},
    response_metadata: {},
    id: "run-cf9e4357-7c7f-46b5-a279-41a2973565af-tool-call_lOeaSFXOwgScogU9qzL9RBdH",
    type: "tool",
  },
  {
    type: "human",
    content: "hi",
  },
  {
    content: "Hello! How can I assist you today?",
    additional_kwargs: {},
    response_metadata: {
      usage: {
        prompt_tokens: 6818,
        completion_tokens: 11,
        total_tokens: 6829,
        prompt_tokens_details: {
          cached_tokens: 0,
          audio_tokens: 0,
        },
        completion_tokens_details: {
          reasoning_tokens: 0,
          audio_tokens: 0,
          accepted_prediction_tokens: 0,
          rejected_prediction_tokens: 0,
        },
      },
    },
    tool_call_chunks: [],
    id: "chatcmpl-BUfPGsrmZ5ZufWkDhOxcWbxis3kEp",
    tool_calls: [],
    invalid_tool_calls: [],
    type: "ai",
  },
  {
    type: "human",
    content: 'Please create a purple button that says "Learn More Now"',
  },
  {
    content: "",
    additional_kwargs: {
      tool_calls: [
        {
          index: 0,
          id: "call_lOeaSFXOwgScogU9qzL9RBdH",
          type: "function",
          function: {
            name: "add_component",
            arguments:
              '{"id":null,"component":{"type":"AdvancedButton","caption1":"Learn More Now","caption1style":{"color":"#ffffff","display":"inline-block","fontFamily":"Arial","fontSize":"1rem","fontWeight":"bold"},"properties":{"display":"inline-block","textAlign":"center","padding":"10px 20px","backgroundColor":"#800080","border":"none","borderRadius":5},"actions":[{"type":"GO_TO_URL","name":"Learn More","payload":{"url":"#"},"behavior":"click"}],"parent":"root","id":"learnMoreButton"}}',
          },
        },
      ],
    },
    response_metadata: {
      usage: {
        prompt_tokens: 6847,
        completion_tokens: 132,
        total_tokens: 6979,
        prompt_tokens_details: {
          cached_tokens: 6784,
          audio_tokens: 0,
        },
        completion_tokens_details: {
          reasoning_tokens: 0,
          audio_tokens: 0,
          accepted_prediction_tokens: 0,
          rejected_prediction_tokens: 0,
        },
      },
    },
    tool_call_chunks: [
      {
        name: "add_component",
        args: '{"id":null,"component":{"type":"AdvancedButton","caption1":"Learn More Now","caption1style":{"color":"#ffffff","display":"inline-block","fontFamily":"Arial","fontSize":"1rem","fontWeight":"bold"},"properties":{"display":"inline-block","textAlign":"center","padding":"10px 20px","backgroundColor":"#800080","border":"none","borderRadius":5},"actions":[{"type":"GO_TO_URL","name":"Learn More","payload":{"url":"#"},"behavior":"click"}],"parent":"root","id":"learnMoreButton"}}',
        id: "call_lOeaSFXOwgScogU9qzL9RBdH",
        index: 0,
        type: "tool_call_chunk",
      },
    ],
    id: "chatcmpl-BUfPbLrBmaymez2d4xHV3hV9UBvHG",
    tool_calls: [
      {
        name: "add_component",
        args: {
          id: null,
          component: {
            type: "AdvancedButton",
            caption1: "Learn More Now",
            caption1style: {
              color: "#ffffff",
              display: "inline-block",
              fontFamily: "Arial",
              fontSize: "1rem",
              fontWeight: "bold",
            },
            properties: {
              display: "inline-block",
              textAlign: "center",
              padding: "10px 20px",
              backgroundColor: "#800080",
              border: "none",
              borderRadius: 5,
            },
            actions: [
              {
                type: "GO_TO_URL",
                name: "Learn More",
                payload: {
                  url: "#",
                },
                behavior: "click",
              },
            ],
            parent: "root",
            id: "learnMoreButton",
          },
        },
        id: "call_lOeaSFXOwgScogU9qzL9RBdH",
        type: "tool_call",
      },
    ],
    invalid_tool_calls: [],
    type: "ai",
  },
  {
    content:
      '{\n  "content": "A AdvancedButton element was added to the page.",\n  "intention": "ADD_COMPONENT",\n  "diff": [\n    {\n      "type": "ADD",\n      "id": null,\n      "value": {\n        "type": "AdvancedButton",\n        "properties": {\n          "display": "inline-block",\n          "textAlign": "center",\n          "padding": "10px 20px",\n          "border": "none",\n          "borderRadius": 5,\n          "backgroundColor": "#800080"\n        },\n        "caption1": "Learn More Now",\n        "caption1style": {\n          "color": "#ffffff",\n          "display": "inline-block",\n          "fontFamily": "Arial",\n          "fontSize": "1rem",\n          "fontWeight": "bold"\n        },\n        "actions": [\n          {\n            "type": "GO_TO_URL",\n            "name": "Learn More",\n            "payload": {\n              "url": "#"\n            },\n            "behavior": "click"\n          }\n        ],\n        "parent": "root",\n        "id": "learnMoreButton"\n      }\n    }\n  ]\n}',
    tool_call_id: "call_lOeaSFXOwgScogU9qzL9RBdH",
    name: "add_component",
    additional_kwargs: {},
    response_metadata: {},
    id: "run-cf9e4357-7c7f-46b5-a279-41a2973565af-tool-call_lOeaSFXOwgScogU9qzL9RBdH",
    type: "tool",
  },
  {
    content:
      'The purple button that says "Learn More Now" has been successfully created! If you need any further modifications or additional components, let me know!',
    additional_kwargs: {},
    response_metadata: {
      usage: {
        prompt_tokens: 7651,
        completion_tokens: 31,
        total_tokens: 7682,
        prompt_tokens_details: {
          cached_tokens: 6912,
          audio_tokens: 0,
        },
        completion_tokens_details: {
          reasoning_tokens: 0,
          audio_tokens: 0,
          accepted_prediction_tokens: 0,
          rejected_prediction_tokens: 0,
        },
      },
    },
    tool_call_chunks: [],
    id: "chatcmpl-BUfPfpmuWaWFnDsW197v0l2nxBBDk",
    tool_calls: [],
    invalid_tool_calls: [],
    type: "ai",
  },
];

export const messagesWithPageContent = [
  {
    content:
      "I'd like to create a landing page for a new product.\n    The product is a new savvy way to manage your finances.\n    It's a mobile app that allows you to track your income and expenses.",
    type: "human",
  },
  {
    name: "page_builder",
    content:
      '{"content":[{"parent":2540,"id":"9cytcwy7lkb","properties":{"width":"62.5rem","padding":"4.375rem","maxWidth":"100%","height":"auto","overflow":"visible","backgroundPosition":"center center","backgroundSize":"cover","backgroundRepeat":"no-repeat","backgroundAttachment":"scroll","backgroundImage":"url()","backgroundColor":"{{ colors.background | default: \'rgb(236,240,241,1)\' }}"},"type":"Section","canHaveChildren":true,"label":"Header"},{"type":"Picture","name":"Image","src":"{{ logo | default: \'https://sandcastleassets.s3.amazonaws.com/dm86ia4h-ropped.png\' }}","properties":{"textAlign":"left","display":"inline-block","width":"7.651785714285714rem","maxWidth":"100%"},"parent":"9cytcwy7lkb","id":"ha2zra4ze5c","oldId":"godw82v2k2q"},{"type":"Spacer","properties":{"height":40,"mobile":{"smartphone":{"height":"2rem","overflow":"visible"},"fullscreen":{"height":"3.75rem","overflow":"visible"}}},"parent":"9cytcwy7lkb","oldId":"rdikw2ziqcd","id":"rdikw2ziqcd"},{"type":"Text","html":"<p><span style=\\"font-size: 2.4rem; font-family: poppins; color: {{ colors.primary | default: \'#000000\' }};\\"><strong style=\\"text-align: center; letter-spacing: 0.1px;\\">Thank You! Your [product purchased] is on your way to your inbox!</strong></span></p>","properties":{"display":"inline-block","padding":5,"textAlign":"center"},"parent":"9cytcwy7lkb","oldId":"77mpal116xe","id":"77mpal116xe","fontsUsed":[],"prompt":"Acknowledge action completed."},{"type":"Text","html":"<p><span style=\\"font-family: hind; font-size: 1.4rem; letter-spacing: 0.1px; text-align: center; color: {{ colors.text | default: \'#000000\' }};\\">[Now, tell the users what to expect next and encourage them to do the next action or step.]</span></p>","properties":{"display":"inline-block","padding":5,"textAlign":"center"},"parent":"9cytcwy7lkb","oldId":"jwh5r30gwln","id":"jwh5r30gwln","fontsUsed":[],"prompt":"Now, tell the reader what to do or expect next."},{"type":"Spacer","properties":{"height":40},"parent":"9cytcwy7lkb","id":"yi08nacmeb9"},{"type":"AdvancedButton","prompt":"What call to action text would you like for your button?","properties":{"display":"inline-block","textAlign":"center","padding":10,"border":"none","borderRadius":63,"backgroundColor":"{{ colors.primary | default: \'rgb(26,73,186,1)\' }}","boxShadow":"0 1px 5px rgba(0,0,0,0.2)","borderWidth":1,"borderStyle":"none","width":"33rem","maxWidth":"100%","borderColor":"#00B1FF","marginTop":"1.5178571428571428rem","mobile":{"smartphone":{"width":"100%","maxWidth":"100%"},"fullscreen":{"width":"33rem","maxWidth":"100%"}}},"hoverStyle":{},"caption1":"Tell The Reader What To Do Now","caption1style":{"fontFamily":"Poppins","fontSize":"1.4285714285714286rem","fontWeight":"bold","color":"{{ colors.accent | default: \'#ffffff\' }}","lineHeight":"35px","display":"block"},"caption2":"","caption2style":{"color":"white","fontSize":"0.8571428571428571rem"},"actions":[{"type":"GO_TO_URL","name":"Go to a Specific Page","payload":false,"behavior":"click"}],"parent":"9cytcwy7lkb","id":"puld3s7gbvq"},{"type":"Spacer","properties":{"height":40},"parent":"9cytcwy7lkb","id":"u4dq13h1atl"},{"parent":2540,"id":"n32mpkioneh","properties":{"width":"62.5rem","padding":"4.375rem","maxWidth":"100%","backgroundSize":"cover","backgroundPosition":"center center","backgroundRepeat":"no-repeat","backgroundImage":"url()","backgroundColor":"{{ colors.background | default: \'rgb(15,90,111,1)\' }}"},"type":"Section","canHaveChildren":true,"label":"CTA","oldId":"9l0nfb95y8i"},{"type":"Picture","name":"Image","src":"{{ logo | default: \'https://sandcastleassets.s3.amazonaws.com/dm86ia4h-ropped.png\' }}","properties":{"textAlign":"center","display":"inline-block","width":"9.375rem","maxWidth":"100%","padding":"0rem","marginTop":"0rem"},"parent":"n32mpkioneh","oldId":"931jxw0874","id":"q49o52j8yml"},{"type":"Spacer","properties":{"height":40,"mobile":{"fullscreen":{"height":"6.25rem","overflow":"visible"}}},"parent":"n32mpkioneh","oldId":"s26w3r9qce9","id":"t8izcdxy5k"},{"type":"Text","html":"<p><span style=\\"color: {{ colors.primary | default: \'#000000\' }}; font-size: 2.8rem;\\"><strong style=\\"text-align: center; font-family: Lato; letter-spacing: 0.1px;\\"><span style=\\"text-align: left; letter-spacing: 0.1px;\\">Thank You!</span></strong></span></p>","properties":{"display":"inline-block","padding":5,"textAlign":"center"},"parent":"n32mpkioneh","oldId":"bstmhiq80vs","id":"bstmhiq80vs","fontsUsed":[],"prompt":"Thank the reader for completing the action."},{"type":"Spacer","properties":{"height":40,"mobile":{"fullscreen":{"height":"2.5rem","overflow":"visible"}}},"parent":"n32mpkioneh","oldId":"sb7d7tmd7ac","id":"rib8hh0bdp9"},{"type":"Text","html":"<p><span style=\\"font-family: \'open sans\'; font-size: 1.4rem; letter-spacing: 0.1px; text-align: center; color: {{ colors.text | default: \'#000000\' }};\\">[Tell the reader what to expect and come up with a strong call to action persuading the reader to act.]</span></p>","properties":{"display":"inline-block","padding":5,"textAlign":"center"},"parent":"n32mpkioneh","oldId":"ijmwdyx14sd","id":"ijmwdyx14sd","fontsUsed":[],"prompt":"Tell the reader what\'s next."},{"type":"Spacer","properties":{"height":40,"mobile":{"fullscreen":{"height":"3.125rem","overflow":"visible"}}},"parent":"n32mpkioneh","oldId":"sb7d7tmd7ac","id":"sb7d7tmd7ac"},{"type":"AdvancedButton","prompt":"What call to action text would you like for your button?","canHaveChildren":false,"properties":{"display":"inline-block","padding":10,"border":"none","backgroundColor":"{{ colors.primary | default: \'rgb(253,153,99,1)\' }}","width":"25rem","borderRadius":4,"cursor":"pointer","borderWidth":1,"borderStyle":"none","borderColor":"#B43BD6","maxWidth":"100%","textAlign":"center","marginTop":"0rem"},"caption1":"Click here","caption1style":{"color":"{{ colors.accent | default: \'#003A48\' }}","fontWeight":"bold","fontSize":"1.2857142857142858rem","fontFamily":"Open Sans"},"parent":"n32mpkioneh","id":"h8571ioouem","actions":[{"type":"GO_TO_URL","name":"Go to a Specific Page","payload":false,"behavior":"click"}],"label":"PRICING2-BUTTON1","oldId":"zbeaxsmsbd"},{"type":"Spacer","properties":{"height":40,"mobile":{"fullscreen":{"height":"6.25rem","overflow":"visible"}}},"parent":"n32mpkioneh","oldId":"of01n7u2lw","id":"s26w3r9qce9"},{"parent":2540,"id":"aian8vyivft","properties":{"width":"62.5rem","padding":"3.125rem","maxWidth":"100%","backgroundColor":"{{ colors.secondary | default: \'rgb(239,100,63,1)\' }}","height":"auto","overflow":"visible","display":"block"},"type":"Section","canHaveChildren":true,"label":"Footer","oldId":"w67a8o539h"},{"type":"Text","html":"<p><span style=\\"font-size: 1rem; font-family: \'open sans\'; color: {{ colors.text | default: \'#000000\' }};\\">Copyright &copy; {{ \\"now\\" | date: \'%Y\' }} {{ companyName }} . All Rights Reserved</span></p>","properties":{"display":"inline-block","padding":5,"textAlign":"center"},"parent":"aian8vyivft","oldId":"okqg751nf5f","id":"u3738mxjqgl","fontsUsed":[]}],"spec":{"action":"create","prompt":"Create a compelling landing page for a mobile app designed to help users manage their finances effectively. The app allows users to track their income and expenses effortlessly, promoting financial health and budgeting.","pageType":"landing","design":"Modern and clean layout with user-friendly navigation, vibrant colors to convey innovation and vitality, and visually engaging elements like charts or graphs to represent financial tracking.","goal":"To generate interest and encourage users to download the app by showcasing its unique features and benefits, demonstrating how it simplifies financial management, and providing a clear call to action to download the app.","sections":[{"name":"Header","type":"Header","prompt":"Create an attention-grabbing headline that highlights the app\'s capabilities.","content":"\\"Take Control of Your Finances with Our Smart Finance App!\\"","goal":"Grab attention and make visitors immediately interested in learning more."},{"name":"Benefit Section","type":"Benefit","prompt":"List the top benefits of using the finance app.","content":"- Effortless tracking of income and expenses\\n- Budgeting tools to help you save\\n- Real-time insights into your financial habits\\n- User-friendly interface for all ages\\n- Secure cloud storage for all your financial data","goal":"Inform visitors about the specific benefits that address their pain points and encourage them to see the value in the app."},{"name":"Content Section","type":"Content","prompt":"Provide in-depth information on how the app works and its features.","content":"Our intelligent finance app simplifies financial management by automatically categorizing your income and expenses, allowing you to set budgets for various categories. With customizable notifications and insightful reports, you can stay on top of your financial goals.","goal":"Educate visitors on the functionality of the app and increase their desire to download it."},{"name":"CTA Section","type":"CTA","prompt":"Craft a compelling call to action inviting users to download the app.","content":"\\"Download Now and Start Your Journey to Financial Freedom!\\"","goal":"Encourage immediate action by making it easy for visitors to download the app."},{"name":"Social Proof Section","type":"SocialProof","prompt":"Include testimonials or reviews from beta testers or early users of the app.","content":"\\"I’ve finally gained control over my spending with this app! – Sarah T.\\"\\n\\"The budgeting features are a game changer for my finances! – Brian K.\\"","goal":"Build trust and credibility by showcasing positive user experiences."},{"name":"Footer","type":"Footer","prompt":"Provide additional navigation links, company information, and social media links.","content":"Contact Us | Privacy Policy | Follow us on Facebook, Twitter, Instagram","goal":"Ensure users have access to important information and can follow the brand for updates."}]}}',
    tool_call_id: "2d53c0d8-56bb-4264-81fb-5cdba7ff4ad6",
    additional_kwargs: {},
    response_metadata: {},
    type: "tool",
  },
];

export const communitySessions = [
  // {
  //   id: "1",
  //   name: "Create a high-converting landing page for a new product launch",
  //   description: "This is a description of session 1",
  //   // image: "https://via.placeholder.com/150",
  //   // video: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  //   price: "0",
  //   categories: "page",
  // },
  {
    id: "cmdjldmwn9gr40811c595db2t",
    name: "Design a marketing funnel that maximizes lead generation for my business coaching business",
    // description: "This is a description of session 2",
    // image: "https://via.placeholder.com/150",
    // video: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    // price: "0",
    categories: "funnel",
  },
  // {
  //   id: "3",
  //   name: "Write compelling copy for an email campaign to nurture leads through the sales funnel",
  //   description: "This is a description of session 3",
  //   // image: "https://via.placeholder.com/150",
  //   // video: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  //   price: "0",
  //   categories: "content",
  // },
];